import { render } from "./continue-button.vue?vue&type=template&id=9e83bd3a&ts=true"
import script from "./continue-button.vue?vue&type=script&lang=ts"
export * from "./continue-button.vue?vue&type=script&lang=ts"

import "./continue-button.vue?vue&type=style&index=0&id=9e83bd3a&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__